module.exports = __webpack_public_path__ + "images/help/video-preview-docs-8e8bfad73739904154456b2f54d4288c.jpg";